export const data = function() {
  return {
    isDebug: true,
    loading: false,
    vendorRequestID: 0,
    tabs: [
      { name: 'vendorRequestDetails', label: 'Details' },
      { name: 'vendorRequestAttachments', label: 'Attachments' },
      { name: 'vendorRequestConversations', label: 'Conversations' }
    ],
    styles: {
      mainContainer: {
        minHeight: '1000px'
      }
    },
    transitionName: 'slide-down',
    showUploadModal: false
  }
}
